export const GTM_LIST_LABEL = 'cross_selling';
export const GTM_PAGE_TYPE = 'upselling';
export const IMPRESSION_CALL_DELAY = 500;
